<div id="kl-confirm-dialog" class="kl-confirm-dialog" [attr.data-tone]="tone()">
  <div class="kl-confirm-dialog__body">
    <div class="kl-confirm-dialog__icon-wrap" aria-hidden="true">
      <i [class]="icon()"></i>
    </div>
    <div class="kl-confirm-dialog__text">
      @if (title()) {
        <h2 class="kl-confirm-dialog__title">{{ title() | translate }}</h2>
      }
      @if (description()) {
        <p class="kl-confirm-dialog__desc">{{ description() | translate }}</p>
      }
    </div>
  </div>

  @if (checkboxLabel()) {
    <div class="kl-confirm-dialog__checkbox">
      <p-checkbox
        [ngModel]="checked()"
        (ngModelChange)="checked.set($event)"
        [binary]="true"
        inputId="klConfirmDialogCheckbox" />
      <label for="klConfirmDialogCheckbox">{{ checkboxLabel() | translate }}</label>
    </div>
  }

  <div class="kl-confirm-dialog__footer">
    <p-button
      type="button"
      size="small"
      [autofocus]="true"
      [severity]="confirmSeverity()"
      [label]="confirmLabel() | translate"
      [loading]="confirmLoading()"
      [disabled]="confirmLoading()"
      (onClick)="onConfirmClick()" />
    @if (!hideCancel()) {
      <p-button
        type="button"
        size="small"
        styleClass="kl-confirm-dialog__no-btn"
        [severity]="cancelSeverity()"
        [label]="cancelLabel() | translate"
        [disabled]="confirmLoading()"
        (onClick)="onCancelClick()" />
    }
  </div>
</div>
